<template>
	<v-dialog v-model="active" width="475" persistent>
		<template v-slot:activator="{ on }">
			<slot name="activator" v-bind="{ on: on }" />
		</template>

		<v-card>
			<v-card-title dark class="dialog-titulo">
				Cadastrar Produtor
			</v-card-title>
			<v-card-text class="pb-0 mb-0 pt-3">
				<v-form ref="formCadastrarLoteDestino">
					<v-row dense class="flex-column">
						<span class="dialog-label">Nome do estabelecimento</span>
						<v-autocomplete color="#008EF0" outlined dense hide-no-data persistent-hint clearable
						                :loading="loadingEstabelecimento" @click:clear="resetarCampos()"
						                :rules="[ESTABELECIMENTO_OBRIGATORIO, ...regrasUep]"
						                v-model="loteDestino.estabelecimento"
						                :items="listaEstabelecimento"
						                item-text="nmEstabelecimento" return-object
						                :search-input.sync="searchEstabelecimento"
						                placeholder="Busque pelo nome do estabelecimento">
							<template v-slot:no-data>
								<v-list-item>
									<v-list-item-title>
										Pesquise pelo nome do estabelecimento
									</v-list-item-title>
								</v-list-item>
							</template>
							<template v-slot:item="{ item }">
								<v-list-item-content>
									<v-list-item-title>
										{{ item.nmEstabelecimento }}
										{{ item.nmLocalidade ? ' - ' + item.nmLocalidade : '' }}
									</v-list-item-title>
									<v-list-item-subtitle v-text="item.nrCodigoOficial" />
								</v-list-item-content>
							</template>
						</v-autocomplete>
					</v-row>

					<v-row dense>
						<v-col cols="9">
							<span class="dialog-label">Nome do produtor/lote</span>
							<v-autocomplete color="#008EF0" outlined dense hide-no-data persistent-hint clearable
							                auto-select-first @click:clear="resetarCampos()"
							                :loading="loadingProdutor"
							                :rules="[PRODUTOR_OBRIGATORIO]"
							                v-model="loteDestino.produtor"
							                :items="listaProdutores"
							                item-text="nmProdutor" return-object
							                :search-input.sync="searchProdutor"
							                placeholder="Busque pelo nome do produtor">
								<template v-slot:no-data>
									<v-list-item>
										<v-list-item-title>
											Pesquise pelo nome do estabelecimento
										</v-list-item-title>
									</v-list-item>
								</template>
								<template v-slot:item="{ item }">
									<v-list-item-content>
										<v-list-item-title>
											{{ item.nmProdutor }}
										</v-list-item-title>
									</v-list-item-content>
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="3">
							<span class="dialog-label">UEP</span>
							<v-autocomplete color="#008EF0" outlined dense auto-select-first
							                no-data-text="Não há Ueps tipo 'WTF ou TR' para este estabelecimento"
							                :rules="[OBRIGATORIO]"
							                v-model="loteDestino.Uep"
							                :items="listaUeps"
							                return-object
							                item-text="nrUnidadeExploracao"
							/>
						</v-col>
					</v-row>

					<v-row dense>
						<v-col cols="4">
							<span class="dialog-label">Estado</span>
							<v-text-field v-model="loteDestino.sgEstado" :loading="loadingMunicipio" color="#008EF0" outlined dense
							              readonly filled />
						</v-col>
						<v-col cols="8">
							<span class="dialog-label">Cidade</span>
							<v-text-field v-model="loteDestino.nmMunicipio" :loading="loadingMunicipio" color="#008EF0" outlined
							              dense
							              readonly filled />
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="mx-3 pb-4">
				<v-btn class="btn-cancelar" color="#FF5252" outlined
				       @click="active = false">
					Cancelar
				</v-btn>
				<v-spacer />
				<v-btn color="#2BC1B6" elevation="0" class="ml-2 white--text" @click="validarForm()"
				       :loading="addingLoteDestino">
					Confirmar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import {mask} from 'vue-the-mask';
import * as moment from "moment";
import {RULES, URLS, MODELS} from '../../resources';
import axios from "axios";
import {mapMutations} from "vuex";

export default {
	name: 'NovoLoteDestinoDialog',
	directives: {mask},
	components: {RULES},
	data: () => ({
		loteDestino: {
			estabelecimento: MODELS.ESTABELECIMENTO,
			produtor: MODELS.PRODUTOR,
			nmProdutor: '',
			cdUep: null,
			sgEstado: '',
			nmMunicipio: '',
		},
		listaEstabelecimento: [],
		listaProdutores: [],
		listaUeps: [],

		searchEstabelecimento: null,
		searchProdutor: null,

		loadingEstabelecimento: false,
		loadingProdutor: false,
		loadingUeps: false,
		loadingMunicipio: false,
		addingLoteDestino: false,
	}),
	computed: {
		regrasUep() {
			if(this.listaEstabelecimento.length > 0 && this.listaUeps.length === 0 && !this.loadingUeps &&
			!this.loadingEstabelecimento)
				return ['Não há UEP tipo "Terminação/Wean-to-finish" cadastrada para este estabelecimento']
			return []
		},
		active: {
			get() {
				return this.addLoteDestinoDialog
			},
			set(v) {
				if (!v) this.resetarCampos()
				this.$emit('update:addLoteDestinoDialog', v)
			}
		}
	},
	methods: {
		...mapMutations("planejamentoAlojamento", [
				"mtChangeListaLoteDestinoAlojamento",
				"mtAdicionarLoteDestinoPreAlojamento",
				"mtIndexarListaLoteDestinoPreAlojamento",
		]),
		...RULES,
		resetarCampos() {
			this.$refs.formCadastrarLoteDestino.resetValidation()
			this.loteDestino.estabelecimento = MODELS.ESTABELECIMENTO
			this.loteDestino.produtor = MODELS.PRODUTOR
			this.loteDestino.nrUep = null
			this.loteDestino.sgEstado = null
			this.loteDestino.nmMunicipio = null
		},
		validarForm() {
			if (this.$refs.formCadastrarLoteDestino.validate()) {
				this.addLoteDestino()
			}
		},
		loadUeps() {
			this.loadingUeps = true
			this.$axios.get(URLS.API_ESTABELECIMENTO +
					'unidadeExploracao/', {
				params: {cdEstabelecimento: this.loteDestino.estabelecimento.idEstabelecimento}
			})
					.then(res => {
						if (!res.data) return

						this.listaUeps = res.data.filter((uep) => uep.csTipoUnidadeExploracao === 'WF' || uep.csTipoUnidadeExploracao === 'TR')
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
					.finally(() => {
						this.loadingUeps = false
					})
		},
		loadMunicipio(cdMunicipio, cdUF) {
			this.loadingMunicipio = true

			let requests = []

			requests.push(this.$axios.get(URLS.API_ESTABELECIMENTO + 'municipio/' + cdMunicipio)
					.then(res => {
						if (!res.data) return

						this.loteDestino.nmMunicipio = res.data.nmMunicipio
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error});
					})
			)
			requests.push(this.$axios.get(URLS.API_ESTABELECIMENTO + 'uf/' + cdUF)
					.then(res => {
						if (!res.data) return

						this.loteDestino.sgEstado = res.data.sgUf
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error});
					})
			)

			Promise.all(requests)
					.finally(() => {
						this.loadingMunicipio = false
					})
		},
		loadEstabelecimentos: _.debounce(function (searchVal) {
			if (this.loteDestino.estabelecimento.nmEstabelecimento === searchVal) return

			let query = {}
			if (searchVal && searchVal.trim()) query['nmEstabelecimento'] = searchVal
			if (this.loteDestino.produtor.cdEstabelecimento > 0)
				query['idEstabelecimento'] = this.loteDestino.produtor.cdEstabelecimento

			this.$axios.get(URLS.API_ESTABELECIMENTO + URLS.ESTABELECIMENTO, {params: query})
					.then(response => {
						this.listaEstabelecimento = response.data ? response.data : []
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
					.finally(() => this.loadingEstabelecimento = false)
		}, 1300),
		loadProdutores: _.debounce(function (searchVal) {
			if (this.loteDestino.produtor.nmProdutor === searchVal) return

			let query = {}

			if (searchVal) query['nmProdutor'] = searchVal
			if (this.loteDestino.estabelecimento.idEstabelecimento > 0)
				query['cdEstabelecimento'] = this.loteDestino.estabelecimento.idEstabelecimento

			this.$axios.get(URLS.API_ESTABELECIMENTO + URLS.PRODUTOR, {params: query})
					.then((response) => {
						this.listaProdutores = response.data ? response.data : []
					})
					.catch((error) => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
					.finally(() => this.loadingProdutor = false)
		}, 1300),
		addLoteDestino() {
			this.addingLoteDestino = true

			const loteDestino = {
				blLoteFechado: false,
				blPreAlojado: false,
				blUltrapassaLimiteVazio: false,
				cdEstabelecimento: this.loteDestino.estabelecimento.idEstabelecimento,
				cdPlanejamentoAlojamento: this.$route.params.id,
				cdProdutor: this.loteDestino.produtor.idProdutor,
				cdUnidadeExploracao: this.loteDestino.Uep.idUnidadeExploracao,
				dtInicioVazio: null,
				idPlanejamentoAlojamentoLoteDestino: null,
				nmEstabelecimento: this.loteDestino.estabelecimento.nmEstabelecimento,
				nmProdutor: this.loteDestino.produtor.nmProdutor,
				nrPavilhao: this.loteDestino.estabelecimento.nrPavilhao,
				nrUnidadeExploracao: this.loteDestino.Uep.nrUnidadeExploracao,
				qtTotalAlocado: 0,
				sgSexoSugerido: null,
				blLoteInexistente: true,
			}
			this.$axios.post('/planejamento-alojamento-lote-destino/', loteDestino)
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.$emit('loadLoteDestinos')
						this.mtAdicionarLoteDestinoPreAlojamento(res.data[0].data)
						this.mtIndexarListaLoteDestinoPreAlojamento()
						this.mtChangeListaLoteDestinoAlojamento([])
						this.$store.commit("setSnack", {type: "success", msg: res.data[0].value});
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error});
					})
					.finally(() => {
						this.addingLoteDestino = false
						this.active = false
					})
		}
	},
	filters: {
		formataData(date, ISO, formatoSaida) {
			let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD'
			const parsedDate = moment(date, tipoData)
			if (!parsedDate.isValid()) return ""
			return parsedDate.format(formatoSaida)
		},
	},
	watch: {
		searchEstabelecimento(val) {
			if (!val) {
				this.loteDestino.estabelecimento = MODELS.ESTABELECIMENTO
				return
			}
			if (val.length < 3) return
			if (val !== this.loteDestino.estabelecimento.nmEstabelecimento) {
				this.loadingEstabelecimento = true
				this.loadEstabelecimentos(val)
			}
		},
		searchProdutor(val) {
			if (!val) {
				this.loteDestino.produtor = MODELS.PRODUTOR
				return
			}
			if (!val && val.length < 3) return
			if (val !== this.loteDestino.produtor.nmProdutor) {
				this.loadingProdutor = true
				this.loadProdutores(val)
			}
		},
		'loteDestino.estabelecimento'(estab, oldVal) {
			if (!estab || !estab.idEstabelecimento) return
			if (this.loteDestino.produtor.idProdutor < 1 &&
					(!oldVal ||
							estab.idEstabelecimento !== oldVal.idEstabelecimento)) {
				this.loadingProdutor = true
				this.loadProdutores()
			}

			if (estab.cdMunicipio > 0 && estab.cdUf > 0) this.loadMunicipio(estab.cdMunicipio, estab.cdUf)
			this.loadUeps()
		},
		'loteDestino.produtor'(prod, oldVal) {
			if (!prod || !prod.idProdutor) return
			if (this.loteDestino.estabelecimento.idEstabelecimento < 1 &&
					(!oldVal ||
							prod.cdEstabelecimento !== oldVal.cdEstabelecimento)) {
				this.loadingEstabelecimento = true
				this.loadEstabelecimentos()
			}
		},
	},
	props: {
		addLoteDestinoDialog: {
			type: Boolean,
			default: true
		},
	}
}
</script>
<style lang="scss" scoped>
@import "src/modules/pedidosRacao/sass/variables";

.dialog-label {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0px;
  color: $gray-300;
}

.dialog-info {
  font: normal normal bold 22px/30px Roboto;
  letter-spacing: 0;
  color: $gray-200;
  text-transform: capitalize;
}

.dialog-titulo {
  text-align: left;
  font: normal 300 normal 16px/21px Roboto !important;
  letter-spacing: 0;
  color: $gray-500;
  opacity: 1;
  background-color: $gray-100;
}

.appended-info {
  color: $gray-200;
  font: normal 500 normal 14px/21px Roboto;
  margin-top: 2px;
}
</style>